import {
  Box,
  CircularProgress,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import Button from "@mui/material/Button";
import React from "react";
import { Form, useNotify } from "react-admin";
import { useParams } from "react-router-dom";
import sendRequest from "../dataProvider/sendRequest";
import HMLogo from "../layout/HMLogo";
import DownloadFieldByPdfLink from "../unit/DownloadFieldByPdfLink";
import UploadImage from "../unit/UploadImage";
import HeaderLabelTitle from "../unit/HeaderLabelTitle";
import HeaderTableLabelValue from "../unit/HeaderTableLabelValue";
import HeaderLabelGridField from "../unit/HeaderLabelGridField";
import FieldShow from "../unit/FieldShow";
import formatCurrency from "../unit/formatCurrency";
import formatDate from "../unit/formatDate";
import { Field } from "react-final-form";
import CustomTable from "../unit/CustomTable";
const PageHeader = () => (
  <Box
    sx={{
      padding: 2,
      textAlign: "left",
      borderBottom: "7px solid #04983F",
      display: "flex",
      alignItems: "center",
      color: "grey",
    }}
  >
    Powered by <HMLogo />
  </Box>
);
const PageFooter = () => (
  <Box
    sx={{
      padding: 2,
      textAlign: "center",
      bottom: 0,
      left: 0,
      right: 0,
    }}
  >
    <Typography variant="body2" sx={{ color: "grey" }}>
      Copyright Happy Mango {new Date().getFullYear()}
    </Typography>
  </Box>
);
type FormValues = {
  email: string;
};

const PaymentSchedulePage = () => {
  const params = useParams();
  const token = params.token;
  const [appId, setAppId] = React.useState(0);
  const [errorMessage, setErrorMessage] = React.useState("");
  const [record, setRecord] = React.useState<any>({});
  const notify = useNotify();

  React.useEffect(() => {
    const fetchBankerInfo = async () => {
      if (token) {
        const reqUrl = "paymentSchedule";
        const response = await sendRequest(reqUrl, {
          id: 0,
          data: { token },
        });
        if (response && response.code == "200") {
          setAppId(response.data.appId || 0);
          setRecord(response || {});
          if (response.data?.paymentlist) {
            //data data
          }
          setErrorMessage("");
        } else {
          // notify("Failed to fetch banker info", { type: "error" });
          notify(response?.message || "Failed to fetch payment info", {
            type: "error",
          });
          setErrorMessage(response?.message || "Failed to fetch payment info");
        }
      }
    };
    fetchBankerInfo();
  }, [token]);

  return (
    <>
      <PageHeader />
      {errorMessage == "" ? (
        <>
          <Box
            sx={{ padding: 2, width: "100%", height: "100%", margin: "auto" }}
          >
            <Box sx={{ maxWidth: "800px", margin: "auto" }}>
              <Grid container spacing={2} sx={{ mb: 2 }}>
                <Grid item xs={12} sm={6} md={6}>
                  {record?.banklogo && (
                    <img
                      src={record?.banklogo || "/images/happymango-logo-b.png"}
                      style={{ maxWidth: "250px" }}
                    />
                  )}
                </Grid>
                <Grid item xs={12} sm={6} md={6}>
                  {/* Applicant Name: hhwmyjxfhvxishsf rpfshgoufr Unpaid Principle
                  Balance: $4,618.84 Original Funding Date: 2025-07-17 Original
                  Maturity Date: 2027-12-17 Payment Frequency: Monthly */}

                  <FieldShow
                    title="Application Name"
                    value={
                      <>
                        {record?.appdata?.firstname}{" "}
                        {record?.appdata?.middlename}{" "}
                        {record?.appdata?.lastname}
                      </>
                    }
                  />
                  <FieldShow
                    title="Unpaid Principle Balance"
                    value={
                      record?.appdata?.sActivePrincipalBalance
                        ? formatCurrency(
                            record?.appdata?.sActivePrincipalBalance || 0
                          )
                        : formatCurrency(
                            record?.appdata?.iLoanAmount ||
                              record?.appdata?.review_iAmount ||
                              0
                          )
                    }
                  />
                  <FieldShow
                    title="Original Funding Date"
                    value={
                      record?.appdata?.dNoteDate
                        ? formatDate(record?.appdata?.dNoteDate)
                        : ""
                    }
                  />
                  <FieldShow
                    title="Original Maturity Date"
                    value={
                      record?.appdata?.dMaturityDate
                        ? formatDate(record?.appdata?.dMaturityDate)
                        : ""
                    }
                  />
                  <FieldShow
                    title="Payment Frequency"
                    value={record?.appdata?.sPaymentFrequency || ""}
                  />
                </Grid>
                <Grid item xs={12}>
                  <CustomTable
                    sx={{ minWidth: "100%" }}
                    size="small"
                    aria-label="Payment List"
                  >
                    <TableHead>
                      <TableRow>
                        <TableCell>Payment Number</TableCell>
                        <TableCell>Payment Due Date</TableCell>
                        <TableCell>Expected Payment Amount</TableCell>
                        <TableCell>Interest Amount</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {record?.data &&
                        record?.data.map((vo: any) => (
                          <TableRow key={vo.id}>
                            <TableCell className="center">
                              {vo.iPaymentNumber}
                            </TableCell>
                            <TableCell>
                              {vo.dPaymentDate != null &&
                              vo.dPaymentDate !== "0000-00-00 00:00:00"
                                ? formatDate(vo.dPaymentDate)
                                : ""}
                            </TableCell>
                            <TableCell className="right">
                              {formatCurrency(vo.paymentAmount)}
                            </TableCell>
                            <TableCell className="right">
                              {formatCurrency(vo.interestAmount)}
                            </TableCell>
                          </TableRow>
                        ))}
                      {record?.data == null || record?.data.length === 0 ? (
                        <TableRow>
                          <TableCell colSpan={4} className="center">
                            No payment schedule available.
                          </TableCell>
                        </TableRow>
                      ) : null}
                    </TableBody>
                  </CustomTable>
                </Grid>
              </Grid>
            </Box>
          </Box>
        </>
      ) : (
        <Typography
          sx={{ textAlign: "center", m: 5, fontSize: "1.2rem", color: "red" }}
        >
          {errorMessage}
        </Typography>
      )}
      <PageFooter />
    </>
  );
};
export default PaymentSchedulePage;
